/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.31/esri/copyright.txt for details.
*/
var n,e;function d(n){return null!=n&&!n.running}!function(n){n[n.Idle=0]="Idle",n[n.Rendering=1]="Rendering",n[n.Ready=2]="Ready",n[n.Fading=3]="Fading"}(n||(n={})),function(n){n[n.RG=0]="RG",n[n.BA=1]="BA",n[n.COUNT=2]="COUNT"}(e||(e={}));export{e as CloudsTextureChannels,n as CubeMapState,d as ensureClouds};
